module.exports = __webpack_public_path__ + "img/mwm_metalwarmint.b8628a0.png";